import { Container, Stack } from '@optimus-web/core';
import { LocalizedTypography } from '@mews-commander/ui';
import { SelectField } from '@mews-commander/form';
import { Option } from '@mews-commander/types';
import { AccountingCategoriesGroupType, AccountingCategoryFieldItem } from '../../types';

interface Props {
    titleTextKey?: Mews.TextKey;
    items: Record<string, AccountingCategoryFieldItem>;
    options: Option[];
    prefix?: AccountingCategoriesGroupType;
}

export const FormSection = ({ titleTextKey, items, options, prefix }: Props) => (
    <>
        {titleTextKey ? (
            <Container padding={['200', '0', '0', '0']}>
                <LocalizedTypography textKey={titleTextKey} textStyle="bodyLargeStrong" as="div" />
            </Container>
        ) : null}
        <Stack vertical spacing="200">
            {Object.entries(items)
                .filter(([_, item]) => item.show ?? true)
                .map(([key, item]) => (
                    <SelectField
                        key={key}
                        options={options}
                        name={prefix ? `${String(prefix)}.${key}` : key}
                        label={item.label}
                    />
                ))}
        </Stack>
    </>
);
